import React, { useState, useEffect } from 'react'
import "./news.css"
import { Article, premiumarticleinfo } from "../../../components/newsbar/articles"
import { db, auth, app, } from '../../../setup/Firebase'; // Import your Firebase instance
import { useAuth } from '../../../setup/AuthContext'
import { collection, doc, setDoc, addDoc, getFirestore, onSnapshot, getDocs, where, query, getDoc} from "firebase/firestore";
import EachNews from '../eachnews/EachNews'
import { createCheckoutSession, getProducts, getStripePayments, getCurrentUserSubscription, get, getCurrentUserSubscriptions} from "@invertase/firestore-stripe-payments";
import { Helmet } from 'react-helmet';
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
export default function PremiumNews() {
  
  const news = premiumarticleinfo.map(article => {
      return (
        <EachNews
          key={article.id}
          {...article}
        />
      )
  })   
  const payments = getStripePayments(app, {
    productsCollection: "products",
    customersCollection: "customers",
  });
  
  function CheckoutButton() {
    const [isLoading, setIsLoading] = useState(false);

    const handleCheckout = async () => {
      setIsLoading(true);
      try {
        const session = await createCheckoutSession(payments, {
          price: 'price_1Ox55FLUOgST0iEQH9VETIlg',
        });
        window.location.assign(session.url);
      } catch (error) {
        console.error('Error initiating checkout:', error);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <button onClick={handleCheckout} disabled={isLoading}>
        {isLoading ? 'Loading...' : 'Subscribe'}
      </button>
    );
  }

  function CheckSubscription() {
    const [isLoading, setIsLoading] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
      checkSubscription();
    }, []);

    const checkSubscription = async () => {
      setIsLoading(true);
      try {
        const session = await getCurrentUserSubscriptions(payments, {
          price: 'price_1Ox55FLUOgST0iEQH9VETIlg',
        });
        setIsSubscribed(session[0]?.status === 'active');
        
        // Check if the user is an admin
        // You need to replace the following with your admin check logic
        const user = auth.currentUser; // Assuming you're using Firebase Auth
        const isAdminUser = await checkAdminStatus(user); // Implement checkAdminStatus function
        
        setIsAdmin(isAdminUser);
      } catch (error) {
        console.error('Error checking subscription:', error);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <>
        {/* {isSubscribed || isAdmin ? (
          <div>{news}</div>
        ) : (
          <div className='emas_news-content_button'>
            <p>You need to subscribe to view premium content.</p>
            <CheckoutButton />
          </div>
        )} */}
        <div style={{ display: auth ? 'block' : 'none'}}>{news}</div>
      </>
    );
  }  


  // Function to check if the user is an admin
  async function checkAdminStatus() {
    auth.currentUser.getIdToken(true)
    const docRef = doc(db, "admin", auth.currentUser.uid);
    const docSnap = await getDoc(docRef);
    return docSnap.exists()
  }


  return (
    <div className='emas__news'>
        <div className='emas__news-heading'> 
            <h1>Premium</h1>
            {/* <a href='https://buy.stripe.com/test_dR62bkgc64VYaUobII'  target="_blank" >https://buy.stripe.com/test_dR62bkgc64VYaUobII</a> */}
            <p>Client only insights and analysis of the Western Australian electricity market</p>
            <p>Electricity Market Advisory Services Pty Ltd (ACN 33 663 507 828) does not guarantee, and accepts no legal liability arising from or connected to, the accuracy, reliability, currency or completeness of any material contained on this website. Parties should seek appropriate independent professional advice prior to relying on or entering into any commitment based on material published here.</p>
            {/* <Helmet>
            <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
            </Helmet>
            <stripe-pricing-table pricing-table-id="prctbl_1OU9dLLUOgST0iEQtjN8miYs" 
publishable-key="pk_test_51OTGZbLUOgST0iEQfKn99PWWI0TP819zx99P375IzGW4jYjqYTfbUfy3j8lYcymDuI9mmXqoLB8WZOm7qJCrnvEg007LwKCYJu">
            </stripe-pricing-table> */}
        </div>
        <section className='emas__news-content'>
          <CheckSubscription />
        </section>
    </div>
  )
}

